/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */
// SLIDER IN FEATURED COLLECTION ON HOME PAGE (ONLY MOBILE VIEW)
var divCheckingInterval = setInterval(function () {
  // Find it with a selector
  if (document.querySelector("span.affirm-ala-price")) {
    var check_div = $("span.affirm-ala-price").html();
    console.log(check_div);
    if (check_div == "") {
      $(".ProductMeta__PriceList.Heading").addClass("affirm_tag_no_content");
    }
    clearInterval(divCheckingInterval);
    // Do something
  }
}, 1000);
$(document).ready(function () {
  // $('body').on('click', '.Popover__ValueList button', function(){
  //     var sel_color = $(this).text();
  //     var down_case_color = sel_color.toLowerCase();
  //     // alert(down_case_color.replace('/', ''));
  //     var sel_barcode = $('.select-barcode option[value='+down_case_color.replace('/', '')+']').text();
  //     $('.ProductMeta__SkuNumber').text(sel_barcode);
  // });

  slick_resize();
  //   window.addEventListener("resize",function(){
  //     if(window.innerWidth < 640){
  //     slick_resize();
  //     }
  // })
  function slick_resize() {
    if ($(".slicklist").length > 0) {
      $(".slicklist").each(function () {
        $(this).slick({
          infinite: false,
          slidesToShow: 3,
          arrows: true,
          slidesToScroll: 1,
          prevArrow:
            "<button type='button' class='slick-prev pull-left'><?xml version='1.0' ?><!DOCTYPE svg  PUBLIC '-//W3C//DTD SVG 1.1//EN'  'http://www.w3.org/Graphics/SVG/1.1/DTD/svg11.dtd'><svg height='512px' id='Layer_1' style='enable-background:new 0 0 512 512;' version='1.1' viewBox='0 0 512 512' width='512px' xml:space='preserve' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink'><polygon points='352,115.4 331.3,96 160,256 331.3,416 352,396.7 201.5,256 '/></svg></button>",
          nextArrow:
            "<button type='button' class='slick-next pull-right'><?xml version='1.0' ?><!DOCTYPE svg  PUBLIC '-//W3C//DTD SVG 1.1//EN'  'http://www.w3.org/Graphics/SVG/1.1/DTD/svg11.dtd'><svg height='512px' id='Layer_1' style='enable-background:new 0 0 512 512;' version='1.1' viewBox='0 0 512 512' width='512px' xml:space='preserve' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink'><polygon points='160,115.4 180.7,96 352,256 180.7,416 160,396.7 310.5,256 '/></svg></button>",
          responsive: [
            {
              breakpoint: 9999,
              settings: "unslick",
            },
            {
              breakpoint: 640,
              settings: {
                slidesToShow: 1,
                autoplay: false,
                speed: 400,
                arrows: true,
                slidesToScroll: 1,
                infinite: false,
                dots: false,
                prevArrow:
                  "<button type='button' class='slick-prev'><?xml version='1.0' ?><!DOCTYPE svg  PUBLIC '-//W3C//DTD SVG 1.1//EN'  'http://www.w3.org/Graphics/SVG/1.1/DTD/svg11.dtd'><svg height='512px' id='Layer_1' style='enable-background:new 0 0 512 512;' version='1.1' viewBox='0 0 512 512' width='512px' xml:space='preserve' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink'><polygon points='352,115.4 331.3,96 160,256 331.3,416 352,396.7 201.5,256 '/></svg></button>",
                nextArrow:
                  "<button type='button' class='slick-next pull-right'><?xml version='1.0' ?><!DOCTYPE svg  PUBLIC '-//W3C//DTD SVG 1.1//EN'  'http://www.w3.org/Graphics/SVG/1.1/DTD/svg11.dtd'><svg height='512px' id='Layer_1' style='enable-background:new 0 0 512 512;' version='1.1' viewBox='0 0 512 512' width='512px' xml:space='preserve' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink'><polygon points='160,115.4 180.7,96 352,256 180.7,416 160,396.7 310.5,256 '/></svg></button>",
              },
            },
          ],
        });
      });
    }
  }
});

if ($(window).width() < 640) {
  $("button.slickrefresh").click(function () {
    setTimeout(function () {
      $(".slicklist").slick("refresh");
    }, 1000);
  });
}
$(document).ready(function () {
  setTimeout(function () {
    $("a.affirm-modal-trigger").text("Learn more");
  }, 5000);

  $(document).on(
    "click",
    ".Product__OffScreen .Popover__ValueList",
    function () {
      setTimeout(function () {
        var getUrl = window.location.href;
        var splitVariant = getUrl.split("?variant=");
        $(".variant-id-cstm-cls").attr("value", splitVariant[1]);
      }, 1000);
    }
  );

  $(document).on(
    "click",
    ".ColorSwatchList .HorizontalList__Item",
    function () {
      setTimeout(function () {
        var getUrl = window.location.href;
        var splitVariant = getUrl.split("?variant=");
        $(".variant-id-cstm-cls").attr("value", splitVariant[1]);
      }, 1000);
    }
  );
});
$(".HorizontalList__Item").change(function () {
  setTimeout(function () {
    $("a.affirm-modal-trigger").text("Learn more");
  }, 1000);
});
function printDiv() {
  var printContents = document.getElementById("view_deatilss").innerHTML;
  //      var originalContents = document.body.innerHTML;

  //      document.body.innerHTML = printContents;

  //      window.print();

  //      document.body.innerHTML = originalContents;

  window.print();
}
// Quick & dirty toggle to demonstrate modal toggle behavior

$(".product_deatilsss").click(function () {
  $(".popup_div.product_custom_view").show();
  $(".popup_div.product_custom_view").removeClass("animation-start");
  $(".modal3").removeClass("model_animation-start");
  var get_value = $(this).parents(".Swatches_inner").find("input").val();
  var full_url = "/products/" + get_value + "?view=custom-view";
  $.ajax({
    url: full_url,
    type: "GET",
    dataType: "html",
    success: function (data) {
      $(".popup_div.product_custom_view").addClass("animation-start");
      $(".modal3").addClass("model_animation-start");
      $(".product_custom_view").html($(data).find(".product_wrapper").html());
    },
  });
});
$(document).on("click", ".add_to_cart", function () {
  var ID = $(this).attr("data-value");
  $.ajax({
    type: "POST",
    url: "/cart/add.js",
    data: {
      quantity: 1,
      id: ID,
    },
    dataType: "json",
    success: function (product) {
      $(".sucess_message").fadeIn();
      $(".sucess_message").fadeOut(2000);
      // fade in
      setTimeout(function () {
        $(".popup_div.product_custom_view").removeClass("animation-start");
        $(".modal3").removeClass("model_animation-start");
      }, 2000);
      document.documentElement.dispatchEvent(
        new CustomEvent("cart:refresh", {
          bubbles: true, //this code is for prestige theme, is to refresh the cart
        })
      );
      document.dispatchEvent(
        new CustomEvent("product:added", {
          bubbles: true,
          detail: {
            variant: productid,
          },
        })
      );
    },
  });
});

$(document).on("click", ".continue_browser", function () {
  parent.history.back();
});
$(document).on("click", ".close_button_custom_popup", function () {
  $(".popup_div.product_custom_view").hide();
  $(".modal3").removeClass("model_animation-start");
  //$.mobile.back();
});

/* Collection filter */
$('.filter_trigger_custom').each(function() {
  $(this).on('click', function() {
    $(".custom_filter-applyjtpl").trigger("click");
    setTimeout(() => {
      $(".ProductListWrapper .ProductList .Grid__Cell").each(function () {
        if ($(this).find(".ProductItem__PriceList .wsgRetailPrice").length) {
          $(this).find(".ProductItem__PriceList").removeClass("childnotExists");
          $(".CollectionInner .ProductItem__PriceList").show();
        } else {
          $(this).find(".ProductItem__PriceList").addClass("childnotExists");
          $(".CollectionInner .ProductItem__PriceList").show();
        }
      });
      setTimeout(function(){
        $('.slider-for').slick('unslick');
        $('.slider-nav').slick('unslick');
      }, 200);
   /*Quick View JS start*/
     function sliderFor(){
      return {
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: true,
        fade: true,
        asNavFor: '.slider-nav',
        prevArrow:'<button class="previous-btn-cls-ctm"><svg aria-hidden="true" viewBox="0 0 512 512" class=""><path fill="currentColor" d="M358 512c4 0 7-1 9-4 5-5 5-13 0-18L146 269 367 47c5-5 5-13 0-18s-13-5-18 0L119 260c-5 5-5 13 0 18l230 230c3 3 6 4 9 4z"></path></svg></button>',
        nextArrow:'<button class="next-btn-cls-ctm"><svg aria-hidden="true" viewBox="0 0 512 512" class=""><path fill="currentColor" d="M128 512c-3 0-7-1-9-4-5-5-5-13 0-18l221-221L119 47c-5-5-5-13 0-18s13-5 18 0l230 231c5 5 5 13 0 18L137 508c-2 3-6 4-9 4z"></path></svg></button>'
      }
    }
  
    function sliderNav(){
      return {
        slidesToShow: 4,
        slidesToScroll: 1,
        asNavFor: '.slider-for',
        centerMode: false,
        arrows: false,
        focusOnSelect: true
      }
    }
       $('.quick-view-button-wrapper').on('click', function() {
      var productId = $(this).data('product-handle');
      var product_price = $(this).parents('.ProductItem__Wrapper').find('.ProductItem__PriceList').html();
      const product_vendor = $(this).parents('.ProductItem__Wrapper').find('.ProductItem__Vendor').text();
      $.get('/products/' + productId + '?view=quick-view', function(data) {
        $('#quick-view-popup').html(data);
        $('#quick-view-popup').find('.product-price').html(product_price);
        $('#quick-view-popup').find('.ProductItem__Vendor').html(product_vendor);
        $('#quick-view-popup').fadeIn();
        setTimeout(function(){
          $('.slider-for').slick(sliderFor());
          $('.slider-nav').slick(sliderNav());
        }, 500);
      });
    });
    }, 1000);
  });
});
// prodct page add to cart js
$(document).on(
  "click",
  ".template-index .ProductForm__AddToCart",
  function (e) {
    e.preventDefault();
    var selectedAmount = $('input[name="option-0"]:checked').val();
    // console.log("Selected Amount: ", selectedAmount);
    var hiddenVariantId = $(".variant-id-cstm-cls").val();
    // console.log("Hidden Variant ID: ", hiddenVariantId);
    var quantity = $('input[name="quantity"]').val();
    //console.log("Quantity:", quantity);
    $.ajax({
      type: "POST",
      url: "/cart/add.js",
      data: {
        quantity: quantity,
        id: hiddenVariantId,
      },
      success: function (data) {
        window.location = "/cart";
      },
    });
  }
);

$(document).on(
  "click",
  "button.ProductForm__AddToCart.Button.Button--primary.Button--full",
  function (e) {
    e.preventDefault();
    var ID = $(".default_product").val();
    if (typeof ID === "undefined") {
      ID = $(".no-js.ProductForm__Option select option:selected").val();
      // ...
    }
    var quantity = $(".ProductForm__QuantitySelector input").val();
    var get_real_quanity = quantity * 1;
    var get_product_id = $(".product_id_get").val();
    $.ajax({
      type: "POST",
      url: "/cart/add.js",
      data: {
        quantity: get_real_quanity,
        id: ID,
      },
      data: jQuery("#" + "product_form_" + get_product_id).serialize(),
      dataType: "json",
      success: function (data) {
        console.log("sucess");
        $("<p class='sucess_message'>✓</p>").insertBefore(
          ".ProductForm__AddToCart span:first"
        );
        var get_text = $(".ProductForm__AddToCart span:first").html();
        $(".ProductForm__AddToCart span:first").html("ADDED TO CART");
        $(".ProductForm__AddToCart span:last").hide();
        $("span.Button__SeparatorDot").hide();
        setTimeout(function () {
          $(".ProductForm__AddToCart span:first").html(get_text);
          $(".ProductForm__AddToCart span:last").show();
          $(".sucess_message").hide();
          $("span.Button__SeparatorDot").show();
        }, 2000);
        document.documentElement.dispatchEvent(
          new CustomEvent("cart:refresh", {
            bubbles: true, //this code is for prestige theme, is to refresh the cart
          })
        );
      },
      error: function (data, errorThrown) {
        $(".error_message").fadeIn();
        $(".error_message").fadeOut(2000);
      },
    });
  }
);

/******* Split product title **********/
$(".Swatches_inner .title").each(function () {
  var e_text = $(this).text();
  var splited_text = e_text.split(", ");
  $(this).text(splited_text[1]);
});

// Infinite Options by ShopPad
// This theme removes event handlers attached to the add to cart button when the variant changes
// Reinit Infinite Options to reattach event handlers
document.addEventListener("variant:changed", function (event) {
  window.Shoppad.apps.infiniteoptions.init();
});

document.addEventListener("variant:changed", function (event) {
  var variant = event.detail.variant; // Gives you access to the whole variant details
  var get_media_id = variant.featured_media.id;
  var get_element = $(
    "a.Product__SlideshowNavImage.AspectRatio[data-media-id=" +
      get_media_id +
      "]"
  );
  var get_header_height = $(".Header__Wrapper").height();
  var get_index = $(
    ".Product__SlideItem[data-media-id=" + get_media_id + "]"
  ).attr("data-image-media-position");
  console.log("variant", get_media_id);
  var $carousel = $(".Product__Slideshow")
    .flickity()
    .flickity("select", get_index);
  $("html, body").animate(
    {
      scrollTop: $(get_element).offset().top - 150,
    },
    1000
  );
});
$(document).on("click", ".for_mobile_custom_class", function () {
  $(".CollectionToolbar__Group.for_desktop button").trigger("click");
});
$(window).on("load resize", function () {
  // var get_height = $(".Header .Header__Wrapper").outerHeight();
  //    var get_heght_px = get_height + "px";
  //    $(".new_collection_page .custom_filter_wrappper.CollectionToolbar.CollectionToolbar--top").css('top',get_heght_px);

  // sticky menu header in product pages
  var mainMenuHeight = $("header .Header__Wrapper").height();
  $(".custom_filter_wrappper.CollectionToolbar.CollectionToolbar--top").css(
    "top",
    mainMenuHeight
  );
});
$.fn.isOnScreen = function () {
  var win = $(window);

  var viewport = {
    top: win.scrollTop(),
    left: win.scrollLeft(),
  };
  viewport.right = viewport.left + win.width();
  viewport.bottom = viewport.top + win.height();

  var bounds = this.offset();
  bounds.right = bounds.left + this.outerWidth();
  bounds.bottom = bounds.top + this.outerHeight();

  return !(
    viewport.right < bounds.left ||
    viewport.left > bounds.right ||
    viewport.bottom < bounds.top ||
    viewport.top > bounds.bottom
  );
};

$(document).ready(function () {
  if ($(".new_collection_page #section-footer").isOnScreen() == true) {
    $(
      ".new_collection_page .CollectionToolbar__Group.for_desktop.sticky-stort-bar-jtpl"
    ).removeClass("sticky_short_bar");
    $(
      ".new_collection_page .CollectionToolbar__Group.for_desktop.sticky-stort-bar-jtpl"
    ).addClass("nonsticky_short_bar");
  } else {
    $(
      ".new_collection_page .CollectionToolbar__Group.for_desktop.sticky-stort-bar-jtpl"
    ).addClass("sticky_short_bar");
    $(
      ".new_collection_page .CollectionToolbar__Group.for_desktop.sticky-stort-bar-jtpl"
    ).removeClass("nonsticky_short_bar");
  }
  $(window).scroll(function () {
    if ($(".new_collection_page #section-footer").isOnScreen() == true) {
      $(
        ".new_collection_page .CollectionToolbar__Group.for_desktop.sticky-stort-bar-jtpl"
      ).removeClass("sticky_short_bar");
      $(
        ".new_collection_page .CollectionToolbar__Group.for_desktop.sticky-stort-bar-jtpl"
      ).addClass("nonsticky_short_bar");
    } else {
      $(
        ".new_collection_page .CollectionToolbar__Group.for_desktop.sticky-stort-bar-jtpl"
      ).addClass("sticky_short_bar");
      $(
        ".new_collection_page .CollectionToolbar__Group.for_desktop.sticky-stort-bar-jtpl"
      ).removeClass("nonsticky_short_bar");
    }
  });
});

$(document).ready(function () {
  setTimeout(function () {
    $(
      ".custom-content-faq .sub-container-faq:nth-child(1) .custom-faq__question"
    ).addClass("open");
    $(
      ".custom-content-faq .sub-container-faq:nth-child(1) .custom-faq__ans"
    ).css("display", "block");
  }, 1000);
});
/* faq page */
$(document).ready(function () {
  // $('.Faq .Faq__Item:nth-child(2) .Faq__ItemWrapper button').trigger('click');

  $(".custm_trade_heading1").click(function () {
    $("html,body").animate(
      {
        scrollTop: $("#shopify-section-fabric-and-finishes").offset().top - 150,
      },
      1500
    );
  });
  $(".custm_trade_heading2").click(function () {
    $("html, body").animate(
      {
        scrollTop: $("#shopify-section-trade-faq").offset().top - 100,
      },
      1000
    );
  });

  $(".custm_trade_heading3").click(function () {
    $("html, body").animate(
      {
        scrollTop: $("#shopify-section-resources-links").offset().top - 100,
      },
      1000
    );
  });
});

$(function () {
  $(".custom-faq__ans:not(:first-of-type)").css("display", "none");
  $(".custom-faq__question :first-of-type").addClass("open");
  $(".custom-faq__question ").click(function () {
    $(".open").not(this).removeClass("open").next().slideUp(300);
    $(this).toggleClass("open").next().slideToggle(300);
  });
});

$(document).ready(function () {
  setTimeout(function () {
    $(".wsg-cart-subtotal-block").after(
      "<p class='custom_shipping_text'>Shipping & taxes calculated at checkout</p>"
    );
  }, 4000);
});

$(".product-section-build-your-own-third-cstm").slick({
  infinite: true,
  slidesToShow: 1,
  slidesToScroll: 1,
  adaptiveHeight: true,
  prevArrow:
    '<img src="https://cdn.shopify.com/s/files/1/1713/4363/files/arowq.png?v=1692966984" class="left-arrow">',
  nextArrow:
    '<img src="https://cdn.shopify.com/s/files/1/1713/4363/files/arowq.png?v=1692966984" class="right-arrow">',
  responsive: [
    {
      breakpoint: 1008,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        infinite: true,
        dots: true,
        arrows: false,
      },
    },
  ],
});

$(document).on(
  "click",
  ".ProductForm__Option .HorizontalList__Item",
  function () {
    var imgID = $(this).attr("data-image-id");
    var getIndex = $(`.slick-slide[media-id="${imgID}"]`).attr(
      "data-slick-index"
    );
    $(".product-section-build-your-own-third-cstm").slick(
      "slickGoTo",
      getIndex
    );
  }
);

// $(document).on('click','.template_build-your-own-third-template .ProductForm__Option .HorizontalList__Item', function(){
//     var varPrice = $(this).attr('var-price');
//     var varComparePrice = $(this).attr('var-compare');
//     var varCompare = varComparePrice ? `| ${varComparePrice} LIST`  : '';
//     $('.template_build-your-own-third-template .main_price_wrappper .price_inner').html(`${varPrice} <span>${varCompare}</span>`);
//     $('.template_build-your-own-third-template .add_to_cart_text').text(`Add to cart ${varPrice} `);
// });

// var price = $('.template_build-your-own-third-template .ProductForm__Option .HorizontalList__Item input[checked="checked"]').parent().attr('var-price');
// var comparePrice = $('.template_build-your-own-third-template .ProductForm__Option .HorizontalList__Item input[checked="checked"]').parent().attr('var-compare');
// var var_compare = comparePrice ? `| ${comparePrice} LIST`  : '';
// $('.template_build-your-own-third-template .main_price_wrappper .price_inner').html(`${price} <span>${var_compare}</span>`);
// $('.template_build-your-own-third-template .add_to_cart_text').text(`Add to cart ${price} `);
$(document).ready(function () {
  var get_url = window.location.href;
  if (get_url.includes("#fabric-finishes")) {
    $(".Product-Mail-Button").removeClass("active");
    $(this).addClass("active");
    $(".modal3").toggleClass("is-visible");
  }
  setTimeout(() => {
    $(".ProductListWrapper .ProductList .Grid__Cell").each(function () {
      if ($(this).find(".ProductItem__PriceList .wsgRetailPrice").length) {
        $(this).find(".ProductItem__PriceList").removeClass("childnotExists");
        $(".CollectionInner .ProductItem__PriceList").show();
      } else {
        $(this).find(".ProductItem__PriceList").addClass("childnotExists");
        $(".CollectionInner .ProductItem__PriceList").show();
      }
    });
  }, 1500);

  getPriceVal();

  function getPriceVal() {
    var getColor = $(
      '.template_build-your-own-third-template .ColorSwatchList input[checked="checked"]'
    ).attr("valhandle");
    var getSize = $(
      ".template_build-your-own-third-template .ProductForm__SelectedValue.newSize"
    ).attr("data-handle");
    if (typeof getColor == "undefined") {
      var varPrice = $("#" + getSize).attr("data-price");
      var compare_price = $("#" + getSize).attr("data-compare");
    } else if (typeof getSize == "undefined") {
      var varPrice = $("#" + getColor).attr("data-price");
      var compare_price = $("#" + getColor).attr("data-compare");
      console.log("test2");
    } else {
      var varPrice = $("#" + getColor + "-" + getSize).attr("data-price");
      var compare_price = $("#" + getColor + "-" + getSize).attr(
        "data-compare"
      );
    }

    var staticPrice = $("#appPrice").val();
    if (typeof staticPrice != "undefined") {
      $(".template_build-your-own-third-template .myprice").remove();
      $(".template_build-your-own-third-template .main_price_wrappper").append(
        `<span class="myprice"> ${staticPrice} | <span class="myprice-cstm-spn">${varPrice} List</span></span>`
      );
    } else {
      setTimeout(function () {
        $(
          ".template_build-your-own-third-template .customer-found.ProductItem__Price .wsgRetailPrice"
        ).remove();
        var getAppPrice = $(
          ".template_build-your-own-third-template .customer-found.ProductItem__Price"
        ).text();
        $(
          ".template_build-your-own-third-template .main_price_wrappper"
        ).append(
          '<input type="hidden" value="' + getAppPrice + '" id="appPrice">'
        );
        $(
          ".template_build-your-own-third-template .main_price_wrappper"
        ).append(
          `<span class="myprice"> ${getAppPrice} | <span class="myprice-cstm-spn">${varPrice} List</span></span>`
        );
      }, 2000);
    }

    var varCompare = compare_price ? `| ${compare_price} LIST` : "";
    $(
      ".template_build-your-own-third-template .main_price_wrappper .price_inner"
    ).html(`${varPrice} <span>${varCompare}</span>`);
    $(
      ".template_build-your-own-third-template .ProductForm button.ProductForm__AddToCart span"
    ).text(`Add to cart ${varPrice} `);
  }
  $(document).on(
    "click",
    ".template_build-your-own-third-template .ColorSwatchList .HorizontalList__Item",
    function () {
      $(".ColorSwatchList .HorizontalList__Item input").removeAttr("checked");
      $(this).find("input").attr("checked", "checked");
      getPriceVal();
    }
  );

  $(document).on(
    "click",
    ".template_build-your-own-third-template .Popover__ValueList button",
    function () {
      $(".ProductForm__SelectedValue").attr(
        "data-handle",
        $(this).attr("size-handle")
      );
      var valData = $(this).attr("size-handle");
      $(".ProductForm__SelectedValue.newSize").attr("data-handle", valData);
      getPriceVal();
    }
  );

  $(document).on("click", ".Popover__ValueList button", function () {
    var valData = $(this).attr("size-handle");
    $(".ProductForm__SelectedValue.newSize").attr("data-handle", valData);
    var getVal = $("#" + valData).val();
    //var getVal1 = $(".no-js.ProductForm__Option select").val(getVal).change();

    $(`.no-js.ProductForm__Option select option`).removeAttr("selected");

    var getColor = $(
      '.template_build-your-own-third-template .ColorSwatchList input[checked="checked"]'
    ).attr("valhandle");
    var getSize = $(
      ".template_build-your-own-third-template .ProductForm__SelectedValue.newSize"
    ).attr("data-handle");
    var Newhandle = getColor + "-" + getSize;
    if (typeof getColor != "undefined" && typeof getSize != "undefined") {
      $(
        `.no-js.ProductForm__Option select option[data-handle="${Newhandle}"]`
      ).attr("selected", "selected");
    } else {
      $(
        `.no-js.ProductForm__Option select option[data-handle="${valData}"]`
      ).attr("selected", "selected");
    }
  });
});
$(
  ".template_build-your-own-third-template .customer-found.ProductItem__Price"
).hide();
var selectedText = $(".ProductForm__SelectedValue").attr("data-handle");
if (typeof selectedText !== "undefined") {
  var selectedText = $(".ProductForm__SelectedValue").attr("data-handle");

  $(".Select--primary input").each(function () {
    if ($(this).attr("show_addcart") == "true") {
      var matchAtrr = $(this).attr("id");
      if (matchAtrr == selectedText) {
        $(".ProductForm__AddToCart").hide();
        $(".ProductForm__QuantitySelector").hide();
        $(".gift-reggie-buttons").hide();
        $(".ProductForm__Label").hide();
      } else {
        $(".ProductForm__AddToCart").show();
        $(".ProductForm__QuantitySelector").show();
        $(".gift-reggie-buttons").show();
        $(".ProductForm__Label").show();
      }
    }
  });
}
var colortext = $(".ColorSwatch__Radio:checked").attr("valhandle");

if (typeof colortext !== "undefined") {
  var colortext = $(".ColorSwatch__Radio:checked").attr("valhandle");

  $(".Select--primary input").each(function () {
    if ($(this).attr("show_addcart") == "true") {
      var matchAtrr = $(this).attr("id");
      if (matchAtrr == colortext) {
        $(".ProductForm__AddToCart").hide();
        $(".ProductForm__QuantitySelector").hide();
        $(".gift-reggie-buttons").hide();
        $(".ProductForm__Label").hide();
      } else {
        $(".ProductForm__AddToCart").show();
        $(".ProductForm__QuantitySelector").show();
        $(".gift-reggie-buttons").show();
        $(".ProductForm__Label").show();
      }
    }
  });
}
$(".Popover__Value ").click(function () {
  var variantpicker = $(this).attr("size-handle");
  $(".Select--primary input").each(function () {
    if ($(this).attr("show_addcart") == "true") {
      var matchAtrr = $(this).attr("id");
      if (matchAtrr == variantpicker) {
        $(".ProductForm__AddToCart").hide();
        $(".ProductForm__QuantitySelector").hide();
        $(".gift-reggie-buttons").hide();
        $(".ProductForm__Label").hide();
      } else {
        $(".ProductForm__AddToCart").show();
        $(".ProductForm__QuantitySelector").show();
        $(".gift-reggie-buttons").show();
        $(".ProductForm__Label").show();
      }
    }
  });
});
$(".ColorSwatch__Radio").click(function () {
  var colortext = $(this).attr("valhandle");
  $(".Select--primary input").each(function () {
    if ($(this).attr("show_addcart") == "true") {
      var matchAtrr = $(this).attr("id");
      if (matchAtrr == colortext) {
        $(".ProductForm__AddToCart").hide();
        $(".ProductForm__QuantitySelector").hide();
        $(".gift-reggie-buttons").hide();
        $(".ProductForm__Label").hide();
      } else {
        $(".ProductForm__AddToCart").show();
        $(".ProductForm__QuantitySelector").show();
        $(".gift-reggie-buttons").show();
        $(".ProductForm__Label").show();
      }
    }
  });
});

if ($(".ProductForm__Option--labelled").length > 1) {
  $(".Popover__Value ").click(function () {
    var variantpicker1 = $(this).attr("size-handle");
    var selected1 = $(".ProductForm__SelectedValue")
      .not(".newSize")
      .attr("data-handle");

    var finaltext = variantpicker1 + "-" + selected1;
    $(".Select--primary input").each(function () {
      if ($(this).attr("show_addcart") == "true") {
        var matchAtrr = $(this).attr("id");
        if (matchAtrr == finaltext) {
          $(".ProductForm__AddToCart").hide();
          $(".ProductForm__QuantitySelector").hide();
          $(".gift-reggie-buttons").hide();
          $(".ProductForm__Label").hide();
        } else {
          $(".ProductForm__AddToCart").show();
          $(".ProductForm__QuantitySelector").show();
          $(".gift-reggie-buttons").show();
          $(".ProductForm__Label").show();
        }
      }
    });
  });
  $(".ColorSwatch__Radio").click(function () {
    var variantpicker1 = $(".ProductForm__SelectedValue.newSize").attr(
      "data-handle"
    );
    var selected1 = $(this).attr("valhandle");

    var finaltext = variantpicker1 + "-" + selected1;
    $(".Select--primary input").each(function () {
      if ($(this).attr("show_addcart") == "true") {
        var matchAtrr = $(this).attr("id");
        if (matchAtrr == finaltext) {
          $(".ProductForm__AddToCart").hide();
          $(".ProductForm__QuantitySelector").hide();
          $(".gift-reggie-buttons").hide();
          $(".ProductForm__Label").hide();
        } else {
          $(".ProductForm__AddToCart").show();
          $(".ProductForm__QuantitySelector").show();
          $(".gift-reggie-buttons").show();
          $(".ProductForm__Label").show();
        }
      }
    });
  });
  var variantpicker2 = $(".ProductForm__SelectedValue.newSize").attr(
    "data-handle"
  );
  var selected2 = $(".ProductForm__SelectedValue")
    .not(".newSize")
    .attr("data-handle");
  var finaltext1 = variantpicker2 + "-" + selected2;
  $(".Select--primary input").each(function () {
    if ($(this).attr("show_addcart") == "true") {
      var matchAtrr = $(this).attr("id");
      if (matchAtrr == finaltext1) {
        $(".ProductForm__AddToCart").hide();
        $(".ProductForm__QuantitySelector").hide();
        $(".gift-reggie-buttons").hide();
        $(".ProductForm__Label").hide();
      } else {
        $(".ProductForm__AddToCart").show();
        $(".ProductForm__QuantitySelector").show();
        $(".gift-reggie-buttons").show();
        $(".ProductForm__Label").show();
      }
    }
  });
}

$(document).ready(function () {
  $(".back-to-top").click(function () {
    $("html, body").animate({ scrollTop: 0 }, 2500);
    return false;
  });
  $(window).scroll(function () {
    if ($(this).scrollTop() > 100) {
      $(".back-to-top").fadeIn();
    } else {
      $(".back-to-top").fadeOut();
    }
  });
});
